var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"invite-buttons d-flex d-sm-none",attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"d-flex justify-center align-center",attrs:{"cols":"6"}},[_c('v-btn',{attrs:{"color":"secondary","depressed":"","text":"","elevation":"0","to":{
        name: 'Page',
        params: { pageName: 'servizi' }
      },"height":"42"}},[_vm._v(_vm._s(_vm.$t("inviteButtons.discover")))])],1),_c('v-col',{staticClass:"d-flex justify-center align-center",attrs:{"cols":"6"}},[_c('v-btn',{attrs:{"color":"primary","text":"","depressed":"","elevation":"0","height":"42","to":{
        name: 'RegistrationUser'
      }}},[_vm._v(_vm._s(_vm.$t("inviteButtons.subscribe")))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }